import * as types from "../actions/provinceTypes";

const initialState = {
    provinceTypes: [],
    loading: false,
    error: null,
};

const provinceTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_PROVINCE_TYPES_REQUEST:
            return { 
                ...state,
                loading: true,
                error: null 
            };

        case types.FETCH_PROVINCE_TYPES_SUCCESS:
            return { 
                ...state, 
                loading: false,
                provinceTypes: action.payload 
            };

        case types.FETCH_PROVINCE_TYPES_FAILURE:
            return { 
                ...state, 
                loading: false,
                error: action.payload 
            };

        default:
            return state;
    }
};

export default provinceTypesReducer;